import { schema } from 'normalizr';

export interface CourseIcon {
  id: string;
  title: string;
  url: string;
}

export const courseIconSchema = new schema.Entity('courseIcons');
